import {
  Title,
  Text,
  Group,
  Divider,
  Box,
  rem,
  Paper,
} from "@mantine/core";
import { useAuth } from "@/context/AuthContext";
import { useBranding } from "@/context/BrandingContext";
import { Navigate } from "react-router-dom";

import OAuthLoginButtons from "@/components/auth/OAuthLogin/OAuthLoginButtons";
import MagicLinkLogin from "@/components/auth/MagicLinkLogin/MagicLinkLogin";
// Rendered as a seam, not inline: this file is .jsx and gets zero type
// diagnostics (allowJs without checkJs), so the branching + copy live in the
// typed component. A follow-up step swaps its not_authorized case for a
// richer card without touching this page.
import AuthErrorNotice from "@/components/auth/AuthErrorNotice";

// Overlay gradient stays constant; the photo underneath is per-brand. A partner
// without its own loginBackgroundUrl falls back to the SAME default photo Verity
// uses (/img/login_bg.jpg) — a neutral background, not Verity branding — so the
// login surface is never bare gradient-only.
const LOGIN_OVERLAY =
  "linear-gradient(135deg, rgba(10, 10, 30, 0.2) 0%, rgba(30, 30, 80, 0.5) 100%)";

export default function Login() {
  const { isAuthenticated, loading } = useAuth();
  const { branding } = useBranding();

  if (!loading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const bgPhoto = branding.loginBackgroundUrl ?? "/img/login_bg.jpg";

  return (
    <Box
      style={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage: bgPhoto
          ? `${LOGIN_OVERLAY}, url("${bgPhoto}")`
          : LOGIN_OVERLAY,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: rem(24),
      }}
    >
      <Paper
        p={rem(40)}
        style={{
          width: '100%',
          maxWidth: '480px',

          // --- LIQUID GLASS STYLING ---
          backgroundColor: 'rgba(16, 16, 16, 0.75)',
          //backdropFilter: 'blur(30px) saturate(150%)',
          WebkitBackdropFilter: 'blur(30px) saturate(150%)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          boxShadow: '0 8px 32px 0 rgba(255, 255, 255, 0.15)',
          borderRadius: rem(24),
        }}
      >
        {/* Header met Logo */}
        <Box mb={30} style={{ textAlign: 'center' }}>
          <Group justify="center" mb={10}>
            <img
              src={branding.logoUrl}
              alt={`${branding.productName} Logo`}
              style={{ height: '70px', width: 'auto' }}
            />
          </Group>
          <Title order={2} fw={900} ta="center" style={{ fontSize: rem(28), color: 'rgba(220, 220, 220, 1)' }}>
            Welcome back
          </Title>
          <Text size="sm" mt={5} ta="center" style={{ color: 'rgba(188, 188, 188, 1)' }}>
            Sign in to continue your data journey.
          </Text>
        </Box>

        {/* SIGN-IN FAILURE MESSAGE — renders nothing when there is none */}
        <AuthErrorNotice />

        {/* GOOGLE LOGIN SECTIE */}
        <Box mb="md" style={{ width: '100%' }}>
          <OAuthLoginButtons />
        </Box>

        <Divider
          label="or sign in with email"
          labelPosition="center"
          my="md"
          styles={{ label: { color: 'rgba(188, 188, 188, 1)' } }}
        />

        {/* MAGIC LINK SIGN-IN */}
        <MagicLinkLogin />
      </Paper>
    </Box>
  );
}
